import { track } from "~/modules/analytics/track";
import { TopTransfersUserEvents } from "~/modules/analytics/events/topTransfers";

// // // //

/**
 * trackTopTransfersTabChange
 * Tracks the event when a user changes a tab in the TopTransfers component
 */
export function trackTopTransfersTabChange(props: {
    prev: string;
    next: string;
}) {
    track(TopTransfersUserEvents.ChangeTab, props);
}

/**
 * trackTopTransfersTimeframeChange
 * Tracks the event when a user changes the timeframe in the TopTransfers component
 */
export function trackTopTransfersTimeframeChange(props: {
    prev: string;
    next: string;
}) {
    track(TopTransfersUserEvents.TimeframeChange, props);
}

/**
 * trackLeagueTableLoginCtaOpen
 * Tracks the event when a user opens the LoginRequiredModal in the TopTransfers component
 */
export function trackTopTransfersLoginCtaOpen(selectedTabKey: string) {
    track(TopTransfersUserEvents.LoginCtaOpen, {
        topTransfersKey: selectedTabKey,
    });
}

/**
 * trackTopTransfersLoginCtaClose
 * Tracks the event when a user closes the LoginRequiredModal in the TopTransfers component
 */
export function trackTopTransfersLoginCtaClose() {
    track(TopTransfersUserEvents.LoginCtaClose);
}

/**
 * trackTopTransfersLoginCtaConfirmed
 * Tracks the event when a user clicks the login button in the LoginRequiredModal in the TopTransfers component
 */
export function trackTopTransfersLoginCtaConfirmed() {
    track(TopTransfersUserEvents.LoginCtaConfirmed);
}
